(function($){


    /* =========================================================
    COOKIES
    ========================================================= */

    tarteaucitron.init({
        "privacyUrl": "", /* Privacy policy url */
        "bodyPosition": "bottom", /* or top to bring it as first element for accessibility */

        "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
        "cookieName": "tarteaucitron", /* Cookie name */

        "orientation": "bottom", /* Banner position (top - bottom - middle - popup) */

        "groupServices": false, /* Group services by category */
        "showDetailsOnClick": true, /* Click to expand the description */
        "serviceDefaultState": "wait", /* Default state (true - wait - false) */

        "showAlertSmall": false, /* Show the small banner on bottom right */
        "cookieslist": false, /* Show the cookie list in a mini banner */
        "cookieslistEmbed": false, /* Show the cookie list on the control panel */
        
        "showIcon": false, /* Show cookie icon to manage cookies */
        "iconSrc": "assets/cookie.svg", /* Optional: URL or base64 encoded image */
        "iconPosition": "BottomRight", /* Position of the icon between BottomRight, BottomLeft, TopRight and TopLeft */

        "adblocker": false, /* Show a Warning if an adblocker is detected */

        "DenyAllCta" : true, /* Show the deny all button */
        "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
        "highPrivacy": true, /* HIGHLY RECOMMANDED Disable auto consent */
        "alwaysNeedConsent": false, /* Ask the consent for "Privacy by design" services */
        
        "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

        "removeCredit": true, /* Remove credit link */
        "moreInfoLink": true, /* Show more info link */
        "useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */
        "useExternalJs": false, /* If false, the tarteaucitron.services.js file and lang files will be loaded */

        // "cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for subdomain website */

        "readmoreLink": "", /* Change the default readmore link pointing to tarteaucitron.io */
        
        "mandatory": true, /* Show a message about mandatory cookies */
        "mandatoryCta": true, /* Show the disabled accept button when mandatory on */
        
        // "customCloserId": "", /* Optional a11y: Custom element ID used to open the panel */

        "googleConsentMode": true, /* Enable Google Consent Mode v2 for Google ads and GA4 */
        "bingConsentMode": false, /* Enable Bing Consent Mode for Clarity and Bing Ads */
        "softConsentMode": false, /* Soft consent mode (consent is required to load the services) */

        "dataLayer": false, /* Send an event to dataLayer with the services status */
        "serverSide": false, /* Server side only, tags are not loaded client side */
        
        "partnersList": false /* Details the number of partners on the popup and middle banner */
    });


    tarteaucitron.user.gtagUa = 'G-9375DQKWZX';
    // tarteaucitron.user.gtagCrossdomain = ['example.com', 'example2.com'];
    tarteaucitron.user.gtagMore = function () { /* add here your optionnal gtag() */ };
    (tarteaucitron.job = tarteaucitron.job || []).push('gtag');

    document.querySelectorAll('a[href="#tarteaucitron"]').forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            if (window.tarteaucitron && tarteaucitron.userInterface && typeof tarteaucitron.userInterface.openPanel === 'function') {
                tarteaucitron.userInterface.openPanel();
            } else {
                window.location.hash = '#tarteaucitron';
            }
        });
    });


      // ===== Modal Mentions légales =====
  const legalModal   = document.getElementById('legal-modal');
  const legalTrigger = document.getElementById('legal-trigger');
  const legalClose   = document.getElementById('legal-close');
  const legalContent = legalModal?.querySelector('.legal-content');
  const baseUrl = window.location.href.split('#')[0];
  let scrollLockY = null;

  const setScrollLock = (on) => {
    if (on && scrollLockY === null) {
      scrollLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('no-scroll');
      document.body.classList.add('no-scroll');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollLockY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    } else if (!on && scrollLockY !== null) {
      const restoreY = scrollLockY;
      scrollLockY = null;
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('no-scroll');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, restoreY);
    }
  };

  function openLegalModal(event, { skipHash = false } = {}){
    if (!legalModal) return;
    if (event instanceof Event) event.preventDefault();
    if (legalModal.classList.contains('active')) return;

    setScrollLock(true);
    legalModal.classList.add('active');
    legalModal.setAttribute('aria-hidden', 'false');
    if (!skipHash) history.replaceState(null, '', `${baseUrl}#mentions-legales`);

    if (legalContent) legalContent.focus({ preventScroll: true });
  }

  function closeLegalModal({ returnFocus = true } = {}){
    if (!legalModal || !legalModal.classList.contains('active')) return;
    legalModal.classList.remove('active');
    legalModal.setAttribute('aria-hidden', 'true');
    setScrollLock(false);
    history.replaceState(null, '', baseUrl);
    if (legalTrigger && returnFocus) legalTrigger.focus();
  }

  legalTrigger?.addEventListener('click', (e) => openLegalModal(e));
  legalClose?.addEventListener('click', () => closeLegalModal());
  legalModal?.addEventListener('click', (e) => { if (e.target === legalModal) closeLegalModal(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLegalModal(); });
  window.addEventListener('hashchange', () => {
    if (window.location.hash === '#mentions-legales') {
      openLegalModal(null, { skipHash: true });
    } else {
      closeLegalModal({ returnFocus: false });
    }
  });
  if (window.location.hash === '#mentions-legales') openLegalModal(null, { skipHash: true });




    // animate scroll
    $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 2000, function() {
                    var $target = $(target);
                    $target.focus();

                    if ($target.is(":focus")) {
                        return false;
                    } else {
                        $target.attr('tabindex','-1');
                        $target.focus();
                    };
                });
            }
        }
    }); 


    // Animations  -----------------------
    var ctrl = new ScrollMagic.Controller();

    var home            = $('#home');
    var esprit          = $('#esprit .article-1');
    var lieu_1            = $('#lieu .article-1');
    var lieu_2           = $('#lieu .article-2');
    var lieu_3            = $('#lieu .article-3');
    var restaurant      = $('#restaurant');
    var cave            = $('#cave');
    var heritage        = $('#heritage');
    var contact         = $('#contact');

    // Create scenes for header        
    $(home).each(function(i) {

        let $logo = $('.header .content')
        let $goto = $('.header .goTo')
        // -----------------------------------
        TweenMax.set($logo, {alpha: 0, y: -120})
        TweenMax.set($goto, {alpha: 0, y: -120})

        var tl_1 = new TimelineMax()

        // animations 
        .to(home.find('.header .content'), 1, {alpha: 1, y: 0})
        .to(home.find('.header .goTo'), 0.75, {alpha: 1, y: 0})

        // -----------------------------------
    
        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.85,
            reverse: false
        })
        .setTween(tl_1)
        .addTo(ctrl);
    });

    // Create scenes for esprit        
    $(esprit).each(function(i) {
        
        let $bgImg = $('#esprit .article-1 .bgImg')
        let $bloc = $('#esprit .article-1 .blocContent')
        // -----------------------------------
        TweenMax.set($bgImg, {alpha: 0})
        TweenMax.set($bloc, {alpha: 0, y: -150})

        var tl_2 = new TimelineMax()

        // animations 
        .to(esprit.find('.bgImg'), 0.75, {alpha: 1})
        .to(esprit.find('.blocContent'), 0.75, {alpha: 1, y: 0})

        // -----------------------------------
    
        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.85,
            reverse: false
        })
        .setTween(tl_2)
        .addTo(ctrl);
    });

    // Create scenes for lieu        
    $(lieu_1).each(function(i) {
        
        let $pic_1 = $('#lieu .article-1 .grid:nth-child(1) img')
        let $bloc_1 = $('#lieu .article-1 .grid:nth-child(2)')
        // -----------------------------------
        TweenMax.set($pic_1, {alpha: 0, y: 150})
        TweenMax.set($bloc_1, {alpha: 0, y: -150})

        var tl_3 = new TimelineMax()

        // animations 
        .to(lieu_1.find('.grid:nth-child(1) img'), 1, {alpha: 1, y: 0})
        .to(lieu_1.find('.grid:nth-child(2)'), 0.75, {alpha: 1, y: 0})

        // -----------------------------------
    
        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.85,
            reverse: false
        })
        .setTween(tl_3)
        .addTo(ctrl);
    });

    $(lieu_2).each(function(i) {
        let $bloc_1 = $('#lieu .article-2 .content')
        // -----------------------------------
        TweenMax.set($bloc_1, {alpha: 0, y: -150})

        var tl_4 = new TimelineMax()

        // animations 
        .staggerTo(lieu_2.find('.content'), 1, {alpha: 1, y: 0})

        // -----------------------------------
    
        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.85,
            reverse: false
        })
        .setTween(tl_4)
        .addTo(ctrl);
    });

    $(lieu_3).each(function(i) {
        let $bloc_1 = $('#lieu .article-3 .blocContent')
        // -----------------------------------
        TweenMax.set($bloc_1, {alpha: 0, y: -150})

        var tl_5 = new TimelineMax()

        // animations 
        .to(lieu_3.find('.blocContent'), 1, {alpha: 1, y: 0})

        // -----------------------------------
    
        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.85,
            reverse: false
        })
        .setTween(tl_5)
        .addTo(ctrl);
    });

    // Create scenes for restaurant        
    $(restaurant).each(function(i) {
        
        let $bgImg = $('#restaurant .article-1 .bgImg')
        let $bloc = $('#restaurant .article-1 .blocContent')
        // -----------------------------------
        TweenMax.set($bgImg, {alpha: 0})
        TweenMax.set($bloc, {alpha: 0, y: -150})

        var tl_6 = new TimelineMax()

        // animations 
        .to(restaurant.find('.bgImg'), 1, {alpha: 1})
        .to(restaurant.find('.blocContent'), 0.75, {alpha: 1, y: 0})

        // -----------------------------------
    
        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.85,
            reverse: false
        })
        .setTween(tl_6)
        .addTo(ctrl);
    });

    // Create scenes for cave        
    $(cave).each(function(i) {
        
        let $bgImg = $('#cave .article-1 .bgImg')
        let $bloc = $('#cave .article-1 .blocContent')
        // -----------------------------------
        TweenMax.set($bgImg, {alpha: 0})
        TweenMax.set($bloc, {alpha: 0, y: -150})

        var tl_7 = new TimelineMax()

        // animations 
        .to(cave.find('.bgImg'), 1, {alpha: 1})
        .to(cave.find('.blocContent'), 0.75, {alpha: 1, y: 0})

        // -----------------------------------
    
        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.85,
            reverse: false
        })
        .setTween(tl_7)
        .addTo(ctrl);
    });

    // Create scenes for heritage        
    $(heritage).each(function(i) {
        
        let $bgImg = $('#heritage .article-1 .bgImg')
        let $bloc = $('#heritage .article-1 .blocContent')
        // -----------------------------------
        TweenMax.set($bgImg, {alpha: 0})
        TweenMax.set($bloc, {alpha: 0, y: -150})

        var tl_8 = new TimelineMax()

        // animations 
        .to(heritage.find('.bgImg'), 1, {alpha: 1})
        .to(heritage.find('.blocContent'), 0.75, {alpha: 1, y: 0})

        // -----------------------------------
    
        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.85,
            reverse: false
        })
        .setTween(tl_8)
        .addTo(ctrl);
    });

    // Create scenes for contact        
    $(contact).each(function(i) {
        
        let $bloc_1 = $('#contact .article-1 .content')
        let $logo = $('#contact .article-1 .content .logo')
        let $bloc_2 = $('#contact .article-1 .footer')
        // -----------------------------------
        TweenMax.set($bloc_1, {alpha: 0, y: -150})
        TweenMax.set($logo, {alpha: 0})
        TweenMax.set($bloc_2, {alpha: 0, y: -150})

        var tl_9 = new TimelineMax()

        // animations 
        .to(contact.find('.logo'), 1, {alpha: 1})
        .to(contact.find('.content'), 1, {alpha: 1, y: 0})
        .to(contact.find('.footer'), 0.75, {alpha: 1, y: 0})

        // -----------------------------------
    
        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.85,
            reverse: false
        })
        .setTween(tl_9)
        .addTo(ctrl);
    });

    
    // lazysizes - add simple support for background images
    document.addEventListener('lazybeforeunveil', function (e) {
        var bg = e.target.getAttribute('data-bg');
        if (bg) {
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });
    
})(jQuery);